export class IsConnectedAction {
    constructor() {
        this.name = 'IsConnected';
        this.isDeviceAction = true;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSXNDb25uZWN0ZWRBY3Rpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbGliL21vZGVscy9hY3Rpb25zL0lzQ29ubmVjdGVkQWN0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUtBLE1BQU0sT0FBTyxpQkFBaUI7SUFBOUI7UUFDa0IsU0FBSSxHQUFHLGFBQWEsQ0FBQztRQUNyQixtQkFBYyxHQUFHLElBQUksQ0FBQztJQUN4QyxDQUFDO0NBQUEifQ==